import React from 'react';
import { Switch, Route } from 'react-router-dom';

import './Loading.scss';

class LoadingBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingStage: 0,
    };
  }

  startLoading = () => {
    if (this.state.loadingStage === 0) {
      this.setState({ loadingStage: 1 });
    }
  }

  stopLoading = () => {
    if (this.state.loadingStage === 1) {
      this.setState({ loadingStage: 2 }, () => {
        setTimeout(() => {
          this.setState({ loadingStage: 0 });
        }, 1500);
      });
    }
  }

  render() {
    let loadingBarClass = '';
    if (this.state.loadingStage === 1) {
      loadingBarClass = 'startLoading';
    } else if (this.state.loadingStage === 2) {
      loadingBarClass = 'finishLoading';
    }

    return (
      <Switch>
        <Route path="/classroom/courses/:coursename" render={props =>
          <div className={`loadingBar classroom ${loadingBarClass}`} />
        } />
        <Route render={props =>
          <div className={`loadingBar ${loadingBarClass}`} />
        } />
      </Switch>
    );
  }
}

export default LoadingBar;
